import React from "react";
import { createRoot } from "react-dom/client";
import { Auth0Provider } from "@auth0/auth0-react";
import { createBrowserHistory } from "history";
import { BrowserRouter, Routes, Route } from "react-router";
import DisplayPage from "./DisplayPage";
import LandingPage from "./LandingPage";

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { translations } from "./translations";

i18next
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
        fallbackLng: "en",
        detection: {
            order: ['querystring', 'navigator']
        },
        resources: translations
    })

const history = createBrowserHistory();

const onRedirectCallback = (appState) => {
    console.log(`onRedirectCallback ${appState?.returnTo}`);
    history.push(appState?.returnTo ?? window.location.pathname);
};

const AUTH_DOMAIN = "caspianwebmet.uk.auth0.com";
const AUTH_CLIENTID = "JOg2C9DADs975QlVkcFp9RB9shMagioJ";
const AUTH_AUDIENCE = "kashagan-metocean-dashboard";

const providerConfig = {
    domain: AUTH_DOMAIN,
    clientId: AUTH_CLIENTID,
    onRedirectCallback,
    authorizationParams: {
        redirect_uri: window.location.origin + "/display",
    },
};

const root = createRoot(document.getElementById('root'));
root.render(
    <Auth0Provider
        {...providerConfig}
    >
        <BrowserRouter>
            <Routes>
                <Route index element={<LandingPage />} />
                <Route path="/display" element={<DisplayPage />} />
            </Routes>
        </BrowserRouter>
    </Auth0Provider>,
);